<div class="dropdown-wrapper" #dropdownWrapper>
  <button (click)="toggleUserMenu()" class="toggle-btn" pTooltip="Click to view common master" tooltipPosition="top">
    {{loginusername}} <i class="pi pi-chevron-down dropdown-icon" [ngClass]="{ 'rotate': usermenuVisible }"></i>
  </button>
  <div *ngIf="usermenuVisible" class="dropdown-menu flex-megamenu">
    <div *ngFor="let menu of usermenu" class="megamenu-column">
      <div class="menu-title">{{ menu.masterlabel }}</div>
      <div class="menu-content">
        <a *ngFor="let item of menu.submenu" (click)="handleClick(item)" [attr.href]="getHref(item)"
          [ngClass]="{ 'active-menu-item': isActive(returnurl(item.label)) }" [class]="item.class"
          routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
          <i class="{{ item.icon }}"></i>
          {{ item.label }}
        </a>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
 <p-dialog header="Full Backup" [(visible)]="backupModal" [modal]="true" [baseZIndex]="10000"
  [resizable]="false" position="center" [style]="{width: '50%', height: '25%'}">
  <div class="dialog-content-min-excel" style=" text-align: center !important; cursor:auto;">
    <div class="card">
        <p>This function will generate the complete Backup of the Common Masters. An Excel file with different tabs containing various Masters will be generated and placed in the Download directory.</p>
    </div>
  </div>
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="backupModal=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="downloadBackup()"></p-button>
  </div>
</p-dialog>
 
